/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.listConvos'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  readState: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['unread'] }>(),
  ),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['request', 'accepted'] }>(),
  ),
  kind: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['direct', 'group'] }>(),
  ),
  lockStatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['unlocked', 'locked', 'locked-permanently']
    }>(),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  convos: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
      (() => ConvoDefs.convoView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns a page of conversations (direct or group) for the user. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
